// extracted by mini-css-extract-plugin
export default {"base":"style_base__rpsRf","info":"style_info__XwVFv","root":"style_root__iHIIZ"};